import { makeSharedStyles } from "shared/theme/makeSharedStyles";
import { scrollStyles } from "shared/styles";
import {
    andLandscapeOrientation,
    andPortraitOrientation,
    applicationShadowPalettes,
    mediumBreakpoint,
    mobileBreakpoint,
    tabletBreakpoint,
    TxtColor,
} from "shared/theme/defaultTheme";
import { NOTIFICATIONS_LIST_MAX_HEIGHT_PX } from "shared/constants/appConstants";

export const usePopoverStyles = makeSharedStyles(theme => ({
    root: {
        boxShadow: applicationShadowPalettes.primary[24],
        borderRadius: theme.spacing(),
        border: `1px solid ${TxtColor.Txt7}`,
        overflow: "hidden",
    },
    listScrollStyles: {
        ...scrollStyles,
    },
    listRoot: {
        outline: "none",
    },
    titleContainer: {
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexDirection: "column",
        [theme.breakpoints.up(tabletBreakpoint)]: {
            alignItems: "center",
            flexDirection: "row",
            display: "flex",
            width: "100%",
        },
    },
    header: {
        justifyContent: "space-between",
        alignItems: "flex-start",
        [theme.breakpoints.down(mobileBreakpoint)]: {
            paddingRight: theme.spacing(2),
        },
    },
    closeIcon: {
        display: "initial",
        [theme.breakpoints.up(tabletBreakpoint)]: {
            display: "none",
        },
    },
    closeIconButton: {},
    content: {
        padding: theme.spacing(2, 0, 2, 3),
        width: "100%",
        display: "flex",
        flexDirection: "column",
        [theme.breakpoints.up(tabletBreakpoint)]: {
            maxWidth: 472,
            width: "100vw",
        },
        [theme.breakpoints.down(mobileBreakpoint)]: {
            width: "100%",
            height: "100%",
        },
    },
    clearAllButton: {
        marginRight: theme.spacing(3),
    },
    noNotificationsBox: {
        textAlign: "center",
        minHeight: 150,
    },
    noNotificationsImage: {
        marginBottom: theme.spacing(2),
    },
}));

export const useNotificationsListStyles = makeSharedStyles(theme => ({
    notificationsList: ({ hasNotification }: { hasNotification: boolean }) => ({
        display: hasNotification ? "flex" : "initial",
        flexGrow: 1,
        flexShrink: 1,
        paddingRight: theme.spacing(2),
        [`${theme.breakpoints.up(tabletBreakpoint)} ${andLandscapeOrientation}`]: {
            maxHeight: "calc(100vh - 100px)",
        },
        [`${theme.breakpoints.up(tabletBreakpoint)} ${andPortraitOrientation}`]: {
            paddingRight: theme.spacing(3),
            maxHeight: NOTIFICATIONS_LIST_MAX_HEIGHT_PX,
        },
        [theme.breakpoints.up(mediumBreakpoint)]: {
            paddingRight: theme.spacing(3),
            maxHeight: NOTIFICATIONS_LIST_MAX_HEIGHT_PX,
        },
    }),
}));

export const useBadgeStyles = makeSharedStyles({
    badge: {
        fontSize: ".75rem",
        lineHeight: "1rem",
        top: 10,
        right: 10,
    },
});

export const usePopoverClasses = makeSharedStyles({
    paper: {
        overflowY: "hidden",
    },
});

export const useFullScreenPopoverStyles = makeSharedStyles({
    paper: {
        maxWidth: "100%",
        maxHeight: "100%",
        width: "100%",
        height: "100%",
        top: `0px !important`,
        left: `0px !important`,
    },
});

export const useClosePopoverIconStyles = makeSharedStyles({
    root: {
        width: 36,
        height: 36,
    },
});

export const useClosePopoverButtonStyles = makeSharedStyles({
    root: {
        paddingTop: 0,
    },
});
